import { CreateUserRequestDto } from '@repo/services/hooks';
import { makeSearchParams } from '@repo/utils';

import http from 'services/http';
import { CreateUserResponseDto } from 'utils/auth';

type PasswordForgotRequestDto = {
  username: string;
  email: string;
};

export const postPasswordForgot = async ({ username, email }: PasswordForgotRequestDto) =>
  await http.post('/password/forgot', { username, email }, { useToken: false, useErrorToast: false });

export const postRegisterUser = async (createUserRequestDto: CreateUserRequestDto) => {
  return await http.post<CreateUserResponseDto>('/users', createUserRequestDto, { useToken: false });
};

export const postKakaoToken = async (encodedOrigin: string, code: string) => {
  return await http.post<any>(
    'https://kauth.kakao.com/oauth/token',
    makeSearchParams({
      grant_type: 'authorization_code',
      client_id: import.meta.env.VITE_APP_KAKAO_KEY,
      redirectUri: encodedOrigin,
      code,
      client_secret: import.meta.env.VITE_APP_KAKAO_SECRET,
    })
  );
};

type KakaoLoginRequestDto = {
  token: string;
};
export const postKakaoLogin = async (kakaoToken: string) =>
  http.post<KakaoLoginRequestDto>('/auth/kakao', { accessToken: kakaoToken });

// export const postKakaoLogin = async (kakaoToken: string) =>
// axiosInstance.post('/auth/kakao', { accessToken: kakaoToken });

export interface CustomTokenDto {
  token: string;
}
type BubbletapLoginRequestDto = {
  username: string;
  password: string;
};
export const postBubbletapLogin = async ({ username, password }: BubbletapLoginRequestDto) =>
  await http.post<CustomTokenDto>('/auth/password', { username, password }, { useToken: false, useErrorToast: false });
